import { Action } from '@ngrx/store';
import { Material, OrderDetailTO } from '../edit-florder-detail/florder-detail.interface';
import { Definitions } from '../definitions/definitions.interface';
import { CCREditMaterialLine } from 'app/core/store/edit-ccr-detail/ccr-detail.interface';

export const CCRDETAIL_CREATE_START = 'ccrDetail:CCRDETAIL_CREATE_START'; // Start create-window
export const CCRDETAIL_OPEN = 'ccrDetail:CCRDETAIL_OPEN';
export const CCRDETAIL_OPEN_SUCCESS = 'ccrDetail:CCRDETAIL_OPEN_SUCCESS';
export const CCRDETAIL_OPEN_FAIL = 'ccrDetail:CCRDETAIL_OPEN_FAIL';
export const CCRDETAIL_CREATE_SAVE_MATERIAL = 'ccrDetail:CCRDETAIL_CREATE_SAVE_MATERIAL';
export const CCRDETAIL_CREATE_SUBMIT = 'ccrDetail:CCRDETAIL_CREATE_SUBMIT'; // Submit 'create ccr' data to middleware
export const CCRDETAIL_CREATE_SUBMIT_FAIL = 'ccrDetail:CCRDETAIL_CREATE_SUBMIT_FAIL'; // Submit failed
export const CCRDETAIL_CREATE_SUBMIT_SUCCESS = 'ccrDetail:CCRDETAIL_CREATE_SUBMIT_SUCCESS'; // Submit successful
export const CCRDETAIL_EDIT_SUBMIT = 'ccrDetail:CCRDETAIL_EDIT_SUBMIT'; // Submit 'create ccr' data to middleware
export const CCRDETAIL_EDIT_SUBMIT_FAIL = 'ccrDetail:CCRDETAIL_EDIT_SUBMIT_FAIL'; // Submit failed
export const CCRDETAIL_EDIT_SUBMIT_SUCCESS = 'ccrDetail:CCRDETAIL_EDIT_SUBMIT_SUCCESS'; // Submit successful
export const CCRDETAIL_CREATE_START_EDIT_MATERIAL = 'ccrDetail:CCRDETAIL_CREATE_START_EDIT_MATERIAL';
export const CCRDETAIL_CREATE_DELETE_MATERIAL = 'ccrDetail:CCRDETAIL_CREATE_DELETE_MATERIAL';

export class CCRDetailCreateStartAction implements Action {
  readonly type = CCRDETAIL_CREATE_START;
  readonly module = 'ccr';

  constructor(readonly payload: { etmOrderNumber: string; salesOrderNumber: string }) {}
}

export class CCRDetailOpenAction implements Action {
  readonly type = CCRDETAIL_OPEN;
  logPayload = true;

  constructor(readonly payload: { etmOrderNumber: string; salesOrderNumber: string, createOrEdit: 'create' | 'edit' }) {}
}

export class CCRDetailOpenSuccessAction implements Action {
  readonly type = CCRDETAIL_OPEN_SUCCESS;
  logPayload = ['orderDetail', 'createOrEdit'];

  constructor(readonly payload: { orderDetail: OrderDetailTO; definitions: Definitions, createOrEdit: 'create' | 'edit' }) {}
}

export class CCRDetailOpenFailAction implements Action {
  readonly type = CCRDETAIL_OPEN_FAIL;
  logPayload = true;

  constructor(readonly payload: any) {}
}

export class CCRDetailCreateSaveMaterialAction implements Action {
  readonly type = CCRDETAIL_CREATE_SAVE_MATERIAL;

  constructor(readonly payload: any) {}
}

export class CCRDetailCreateSubmitAction implements Action {
  readonly type = CCRDETAIL_CREATE_SUBMIT;

  constructor(readonly payload: any) {}
}

export class CCRDetailCreateSubmitFailAction implements Action {
  readonly type = CCRDETAIL_CREATE_SUBMIT_FAIL;
  logPayload = true;

  constructor(readonly payload?: any) {}
}

export class CCRDetailCreateSubmitSuccessAction implements Action {
  readonly type = CCRDETAIL_CREATE_SUBMIT_SUCCESS;
  logPayload = true;

  constructor(readonly payload?: { ccrNumber: string }) {}
}

export class CCRDetailEditSubmitAction implements Action {
  readonly type = CCRDETAIL_EDIT_SUBMIT;

  constructor(readonly payload: any) {
  }
}

export class CCRDetailEditSubmitFailAction implements Action {
  readonly type = CCRDETAIL_EDIT_SUBMIT_FAIL;
  logPayload = true;

  constructor(readonly payload?: any) {
  }
}

export class CCRDetailEditSubmitSuccessAction implements Action {
  readonly type = CCRDETAIL_EDIT_SUBMIT_SUCCESS;
  logPayload = true;

  constructor(readonly payload: { ccrNumber: string }) {
  }
}

export class CCRDetailCreateStartEditMaterialAction implements Action {
  readonly type = CCRDETAIL_CREATE_START_EDIT_MATERIAL;

  constructor(readonly payload: CCREditMaterialLine) {}
}

export class CCRDetailCreateRemoveMaterialAction implements Action {
  readonly type = CCRDETAIL_CREATE_DELETE_MATERIAL;

  constructor(readonly payload: CCREditMaterialLine) {}
}

export type Actions =
  | CCRDetailCreateStartAction
  | CCRDetailOpenAction
  | CCRDetailOpenSuccessAction
  | CCRDetailOpenFailAction
  | CCRDetailCreateSaveMaterialAction
  | CCRDetailCreateSubmitAction
  | CCRDetailCreateSubmitFailAction
  | CCRDetailCreateSubmitSuccessAction
  | CCRDetailEditSubmitAction
  | CCRDetailEditSubmitFailAction
  | CCRDetailEditSubmitSuccessAction
  | CCRDetailCreateStartEditMaterialAction
  | CCRDetailCreateRemoveMaterialAction;
